import styled, { css, keyframes } from 'styled-components';
import { Loader2 } from 'lucide-react';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled(Loader2)`
  animation: 1s linear ${spin} infinite;
  color: #5262aa;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.neutralSilver80};
    font-size: 1.6rem;
    line-height: 24px;
  `}
`;
